import { render } from "./AggregationDetailsModal.vue?vue&type=template&id=57844bbd&scoped=true"
import script from "./AggregationDetailsModal.vue?vue&type=script&lang=js"
export * from "./AggregationDetailsModal.vue?vue&type=script&lang=js"

import "./AggregationDetailsModal.vue?vue&type=style&index=0&id=57844bbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57844bbd"]])

export default __exports__